import type { TransformedFacing } from '@state/shelf/types'

export function stockLevelFacingProducer(selectedGtin?: string) {
  return ({ facing }: {facing: TransformedFacing}) => {
    if (facing.gtin === selectedGtin) {
      switch (facing.stockLevel) {
        case 'HAS_STOCK':
          return 'border-2 border-brand bg-utility-brand-50 hover:bg-utility-brand-500'
        case 'NO_STOCK':
          return 'border-2 border-utility-orange-dark-400 bg-utility-orange-dark-200 hover:bg-utility-orange-dark-400'
        case 'UNKNOWN':
          return 'border-2 border-unknown-stock bg-unknown-stock-bg hover:bg-unknown-stock'
      }
    }

    if (facing.stockLevel === 'NO_STOCK') {
      return 'bg-utility-orange-dark-200'
    }

    return ''
  }
}